export default "__VITE_ASSET__fu2aCHgv__"